@if (!inEdit) {
  <div class="grid-x">
    <div class="cell small-8">
      <h4 class="title">{{geometry.title}}</h4>
      <h5 class="sub-title">{{geometry.type | titlecase}}</h5>
    </div>
    <div class="cell small-4">
      <button class="button small margin-right" (click)="edit()">EDIT</button>
      <button class="button small" (click)="delete()">DELETE</button>
    </div>
  </div>
}
<ng-container #portal></ng-container>
